import React, { Component } from 'react';
import { connect } from 'react-redux';
import server from '../api/server';
import firebase from './Firebase';
import { Helmet } from 'react-helmet';
import history from '../history';

export class ClientAuthRedirect extends Component {

    // Firebase sign-in failures happen entirely in the browser, so the server
    // has no idea why a client bounced back to the login page. Report the reason
    // so it lands in the Discord auth channel. Never send the link itself: it
    // carries a single-use oobCode credential.
    reportLoginFailure = async (stage, error, email) => {
        try {
            await server.post("/client/logLoginFailure", {
                stage: stage,
                code: error?.code || '',
                message: error?.message || String(error || ''),
                email: email || '',
            });
        } catch (e) {
            // Reporting is best-effort; never block the redirect on it.
        }
    };

    componentDidMount() {

        // Confirm the link is a sign-in with email link.
        if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
            // Get email from localStorage
            var email = window.localStorage.getItem('emailForSignIn');

            // If no email in localStorage, try to get it from the URL
            if (!email) {
                const urlParams = new URLSearchParams(window.location.search);
                email = urlParams.get('email');
                
                // Decode the email and replace "%40" with "@"
                if (email) {
                    email = decodeURIComponent(email).replace("%40", "@");
                }
            }

            // If still no email, prompt the user
            if (!email) {
                email = window.prompt('Please provide your email for confirmation');
            }

            // The client SDK will parse the code from the link for you.
            firebase.auth().signInWithEmailLink(email, window.location.href)
                .then(async (result) => {
                    console.log(result);
                    // Clear email from storage.
                    window.localStorage.removeItem('emailForSignIn');
                    var response = await server.post("/client/auth/redirect");
                    if (response && response.data && response.data.application_id) {
                        history.push(`/dashboard/${response.data.application_id}`);
                    } else {
                        // The route returns plain `false` when it can't resolve an
                        // application. This used to fall through and leave the page
                        // sitting on "Redirecting..." forever. The server logs the
                        // reason to Discord; get the client back to a usable page.
                        history.push("/client");
                    }

                    // You can access the new user via result.user
                    // Additional user info profile not available via:
                    // result.additionalUserInfo.profile == null
                    // You can check if the user is new or existing:
                    // result.additionalUserInfo.isNewUser
                })
                .catch(async (error) => {
                    console.log(error);
                    // Common causes: the link was already used, it expired, or
                    // the email it was minted for does not match `email`.
                    await this.reportLoginFailure('Email link sign-in', error, email);
                    // Else redirect to login page
                    history.push("/client");
                    // Some error occurred, you can inspect the code: error.code
                    // Common errors could be invalid email and invalid or expired OTPs.
                });
        } else {
            firebase.auth().onAuthStateChanged(async (user) => {
                if (user) {
                    console.log('logged in.');
                    var response = await server.post("/client/auth/redirect");
                    if (response && response.data && response.data.application_id) {
                        history.push(`/dashboard/${response.data.application_id}`);
                    } else {
                        history.push("/client");
                    }
                    // User is signed in.
                } else {

                    history.push("/client");
                    // No user is signed in.
                }
            });
        }
    }

    authRedirect = async () => {
        var response = await server.post("/client/auth/redirect");
    };
    render() {

        return (
            <div className="min-h-screen bg-gray-100">
                <Helmet>
                    <title>LoanGateway - Mortgage Choice Sydney CBD</title>
                    <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
                </Helmet>
                <div className="flex flex-col items-center justify-center min-h-screen p-4">
                    <div className="text-center">
                        <img 
                            className="mx-auto w-full max-w-xs h-auto mb-8"
                            src={process.env.PUBLIC_URL + '/images/logos/dark_transparent.png'} 
                            alt="LoanGateway Logo" 
                        />
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">Redirecting...</h2>
                        <p className="text-gray-600">Please wait while we process your authentication.</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ClientAuthRedirect);